import {TaxJarCustomer} from 'common'
import {ExemptionType} from 'common/enums'
import {getCountryNameByCode, getStateNameByCode} from 'components/utils'
import {replace, startCase} from 'lodash'
import React, { useEffect, useState } from 'react'
import {FieldSet} from '../DetailFields'
import styles from '../DetailPage.module.scss'

const TaxJarCustomerDetails = (data: TaxJarCustomer) => {
  const [country, setCountry] = useState<any>();
  const [state, setSate] = useState<any>();
  const [exemptRegions, setExemptRegions] = useState<any>();
  
  useEffect(() => {
    (async () => {
      if (!data.country && !data.state) return
      setCountry((data.country && await getCountryNameByCode(data.country)) || '')

      setSate(data.country && data.state
        ? await getStateNameByCode(data.state, data.country)
        : data.state || '')
      
      setExemptRegions(data?.exempt_regions?.length
        ? data?.exempt_regions
            ?.map(async ({country, state}) => [
              {
                label: 'Country',
                value: country ? await getCountryNameByCode(country) : ''
              },
              {
                label: 'State',
                value: country && state ? await getStateNameByCode(state, country) : ''
              }
            ])
            .flat()
        : [{label: 'None', value: ''}])
    })()
  }, [data]);

  
  const customerInformation = [
    {label: 'Customer Name', value: data.name},
    {
      label: 'Exemption Type',
      value: startCase(
        replace(data.exemption_type || ExemptionType.NonExempt, /_/g, ' ')
      )
    },
    {label: 'Country', value: country},
    {
      label: 'State',
      value: state
    },
    {label: 'City', value: data.city},
    {label: 'Street', value: data.street},
    {label: 'Zip', value: data.zip}
  ]

  return (
    <React.Fragment>
      <div className={styles.inputsfields}>
        <FieldSet title="Customer Details" fields={customerInformation} />
      </div>
      <div className={styles.inputsfields}>
        <FieldSet title="Exempt Regions" fields={exemptRegions} />
      </div>
    </React.Fragment>
  )
}

export default TaxJarCustomerDetails
